<template>
  <OptionSummary></OptionSummary>
  <section class="section-map">
    <div class="title">
      <h1>ما اینجا هستیم...</h1>
      <hr class="section-separator" />
    </div>
    <!-- <p
      class="address-share"
      @click="
        ShareMapBtn(
          'فالیزنت',
          this.themeInfo.info?.business.company_name +
            '\n' +
            'آدرس: ' +
            this.themeInfo?.info?.business.address,
          'https://maps.google.com/?q=' +
            this.themeInfo?.info?.business.lat +
            ',' +
            this.themeInfo?.info?.business.long
        )
      "
    >
      آدرس:
      {{ themeInfo?.info?.business.address }}
    </p> -->
    <template v-if="lat && long">
      <a
        v-if="isMobile()"
        class="address-share"
        :href="
          'geo:' +
          themeInfo?.info?.business?.lat +
          ',' +
          themeInfo?.info?.business?.long
        "
        target="_blank"
      >
        آدرس: {{ themeInfo?.info?.business.address }}</a
      >
      <a
        v-else
        class="address-share"
        :href="
          'https://www.google.com/maps/?q=' +
          themeInfo?.info?.business?.lat +
          ',' +
          themeInfo?.info?.business?.long
        "
        target="_blank"
      >
        آدرس: {{ themeInfo?.info?.business.address }}</a
      >
    </template>
    <l-map
      v-if="lat && long"
      style="height: 100%; width: 95%; position: relative; z-index: 1"
      :zoom="zoom"
      :center="MakeLatLng(lat, long)"
      :options="mapOptions"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker ref="marker" :lat-lng="MakeLatLng(lat, long)">
        <l-popup style="width: max-content" ref="popup">
          <b>
            {{ themeInfo?.info?.business?.company_name }}
          </b>
          <img
            :src="'https://witrino.com/' + themeInfo.info?.admin?.img"
            alt=""
          />
        </l-popup>
      </l-marker>
      <div class="fullScreen-map">
        <i class="far fa-expand fa-lg"></i>
      </div>
    </l-map>
  </section>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import { latLng } from "leaflet";
export default {
  name: "mapPage",
  components: {
    OptionSummary,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },

  data() {
    return {
      zoom: 15,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      currentZoom: 11.5,
      lat: null,
      long: null,
      mapOptions: {
        zoomSnap: 0.5,
      },
    };
  },
  watch: {
    themeInfo: {
      handler(newValue) {
        console.log("=========================>");
        console.log(newValue);
        this.lat = this.themeInfo?.info?.business?.lat;
        this.long = this.themeInfo?.info?.business?.long;
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
    }),
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    MakeLatLng(lat, lng) {
      // console.log("sdafdafasdfsdfadasf", lat, lng);
      if (lat && lng) return latLng(lat, lng);
      // return latLng(36.3021147, 59.5942672);
    },

    ShareMapBtn(title, text, url) {
      if (navigator.share !== undefined) {
        navigator
          .share({
            title,
            text,
            url,
          })
          .then(() => console.log("Shared!"))
          .catch((err) => console.error(err));
      } else {
        this.copyTextToClipboard(url);
      }
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }

      document.body.removeChild(textArea);
    },
  },
  created() {
    this.token = this.$route.params.token;
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.marker?.leafletObject.openPopup();
    });
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/map/map.css);
</style>